import type { Middleware } from '@nuxt/types';
import { REFERRAL_PRE_ONBOARDING_PAGE } from '~/constants';

const markingMiddleware: Middleware = ({ route: { name, query }, app: { $cookies }, $auth, redirect }) => {
  const marker = query.mrk || query.marker;
  const invitationHash = query.invitation_hash;
  const markerLifespanInDays = 30;
  const markerCookieParams = { maxAge: 60 * 60 * 24 * markerLifespanInDays, path: '/' };

  const hasInvitation = marker || invitationHash;

  if (marker) {
    $cookies.set('marker', marker, markerCookieParams);
  }
  if (invitationHash) {
    $cookies.set('invitation_hash', invitationHash, markerCookieParams);
  }

  const isPreOnboardingPage = name === REFERRAL_PRE_ONBOARDING_PAGE.name;
  const canSeePreOnboardingPage = hasInvitation && !isPreOnboardingPage && !$auth.loggedIn;

  if (canSeePreOnboardingPage) {
    redirect({ ...REFERRAL_PRE_ONBOARDING_PAGE, query: { ...query } });
  }
};

export default markingMiddleware;
